import { type FormField } from '@wix/ambassador-forms-v1-form-template/types';
import { type Field as TemplateField } from '@wix/ambassador-forms-v2-form-template/types';
import { type FieldsField as FormSchemaField } from '@wix/ambassador-forms-v4-form/types';

import { makeValidationOfInputField } from './make-validation-of-input-field';
import { makeViewOfDisplayProperties } from './make-view-of-display-properties';
import { makeViewOfInputField } from './make-view-of-input-field';

export function transformFieldToV1(
  field: FormSchemaField | TemplateField,
): FormField {
  return {
    id: field.id,
    hidden: field.hidden,
    ...resolveRootProperties(field),
  };
}

function resolveRootProperties(
  field: FormSchemaField | TemplateField,
): Pick<FormField, 'pii' | 'target' | 'validation' | 'view' | 'readOnly'> {
  if (field.inputOptions) {
    return {
      pii: field.inputOptions.pii,
      target: field.inputOptions.target,
      readOnly: field.inputOptions.readOnly,
      view: {
        fieldType: field.identifier,
        ...makeViewOfInputField(field.inputOptions),
      },
      validation: makeValidationOfInputField(field.inputOptions),
    };
  }
  if (field.displayOptions) {
    return {
      view: {
        fieldType: field.identifier,
        ...makeViewOfDisplayProperties(field.displayOptions),
      },
    };
  }

  return {};
}
